<template>
  <v-form
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
    enctype="multipart/form-data"
    lazy-validation
  >
    <v-card :class="{ ['elevation-12']: $vuetify.breakpoint.smAndUp }">
      <v-card-title class="display-1">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-if="!value.protocol_id"
          v-model="value.date"
          :rules="[$rules.required, $rules.date]"
          :autofocus="$vuetify.breakpoint.smAndUp"
          label="Datum"
          type="date"
          box
        ></v-text-field>
        <v-text-field
          v-if="!value.protocol_id"
          v-model="protocolTitle"
          :rules="[$rules.required]"
          label="Titel"
          box
        ></v-text-field>
        <FileInput
          v-model="value.file_id"
          label="Protokoll"
          class="mb-4"
        ></FileInput>
        <p v-if="!value.file_id && !value.protocol_id" class="red--text">
          Es muss ein Dokument erfasst sein um den Vorgang abzuschliessen
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid || (!value.file_id && !value.protocol_id)"
          type="submit"
          color="primary"
          depressed
        >
          {{ submitText }}
        </v-btn>
        <v-btn
          :to="backLink"
          depressed
        >Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  name: 'ProtocolForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: () => '',
    },
    submitText: {
      type: String,
      default: () => 'speichern',
    },
    backLink: {
      type: Object,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      valid: true,
      fileHint: this.edit ? 'Feld leer lassen, wenn keine Änderung vorgenommen werden soll' : null,
      fileRules: this.edit ? [] : [this.$rules.required],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
  },
  computed: {
    protocolTitle: {
      get() {
        return this.value.title || `Grossratsprotokoll vom ${this.$options.filters.toLocaleDateString(this.value.date)}`;
      },
      set(v) { this.value.title = v; },
    },
  },
  watch: {
    'value.date': {
      handler(val) {
        if (val && !this.value.title && new Date(val).getTime() > 0) {
          const formatted = this.$options.filters.toLocaleDateString(val);
          this.value.title = `Grossratsprotokoll vom ${formatted}`;
        }
      },
    },
  },
};
</script>
<style>
.dropzone {
  margin-bottom: 5px !important;
}
</style>

